"use client";
import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { useResizeObserver as f, useMergedRef as C, Box as k, Group as r, Figure as w, Heading as N, Paragraph as i, Icon as R, TextLink as c } from "@ingeniorforeningen/figurine-core";
import { forwardRef as T } from "react";
import '../../../../assets/CardContact.css';const y = "_root_2d1ge_2", M = "_content_2d1ge_14", b = "_media_2d1ge_27", j = "_illustration_2d1ge_38", v = "_texts_2d1ge_55", L = "_header_2d1ge_65", z = "_contactText_2d1ge_76", n = {
  root: y,
  content: M,
  media: b,
  illustration: j,
  texts: v,
  header: L,
  contactText: z
}, m = T((d, h) => {
  const { header: p, subject: l, text: g, contactList: o } = d, [u, x] = f(), _ = C(u, h), a = x.width >= 450;
  return /* @__PURE__ */ e(
    k,
    {
      ref: _,
      p: a ? 0 : "sm",
      className: n.root,
      mod: { withMultipleColumns: a },
      children: /* @__PURE__ */ s(
        r,
        {
          direction: "column",
          spacing: a ? "md" : "sm",
          className: n.content,
          children: [
            /* @__PURE__ */ e(
              r,
              {
                align: "center",
                wrap: "nowrap",
                spacing: "xl",
                className: n.media,
                mod: { withMultipleColumns: a },
                children: /* @__PURE__ */ e(w, { name: "help", className: n.illustration })
              }
            ),
            /* @__PURE__ */ s(
              r,
              {
                spacing: 0,
                className: n.texts,
                mod: { withMultipleColumns: a },
                children: [
                  /* @__PURE__ */ e(N, { type: "h2", mb: "sm", text: p, className: n.header }),
                  l && /* @__PURE__ */ e(i, { text: l, lineClamp: 1, strong: !0 }),
                  /* @__PURE__ */ e(i, { text: g, lineClamp: 2 }),
                  /* @__PURE__ */ e(r, { mt: "sm", children: o && o.length > 0 ? o.map((t) => /* @__PURE__ */ s(r, { align: "center", wrap: "nowrap", spacing: "md", children: [
                    /* @__PURE__ */ e(R, { color: "dark", name: t.icon }),
                    /* @__PURE__ */ s(r, { align: "center", spacing: 0, children: [
                      /* @__PURE__ */ e(i, { text: t.text, className: n.contactText }),
                      t.link.href.startsWith("tel:") ? /* @__PURE__ */ e(
                        c,
                        {
                          variant: "component",
                          text: t.link.text,
                          href: t.link.href,
                          target: t.link.target
                        }
                      ) : /* @__PURE__ */ e(
                        c,
                        {
                          variant: "component",
                          text: t.link.text,
                          href: t.link.href,
                          target: t.link.target
                        }
                      )
                    ] })
                  ] }, t.link.href)) : null })
                ]
              }
            )
          ]
        }
      )
    }
  );
});
m.displayName = "CardContact";
const H = m;
export {
  m as _CardContact,
  H as default
};
